"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _BalancesList = _interopRequireDefault(require("../../components/BalancesList"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./BalancesListLayout.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var balancesListLayoutClasses = (0, _cssClassesHelper.getBEMClasses)('balances-list-layout');
var BalancesListLayout = function BalancesListLayout() {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: balancesListLayoutClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: balancesListLayoutClasses('header')
  }, t('Balances')), /*#__PURE__*/_react["default"].createElement(_BalancesList["default"], null));
};
var _default = exports["default"] = BalancesListLayout;